var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.96187H3.635L7.268 2.38921C7.622 1.93837 7.564 1.26744 7.14 0.892095C6.715 0.51569 6.085 0.577361 5.732 1.0282L0.732 6.34465C0.693 6.39463 0.673 6.45311 0.644 6.5084C0.62 6.55306 0.591 6.59133 0.573 6.64025C0.528 6.76252 0.501 6.89118 0.501 7.0209L0.5 7.02516L0.501 7.02941C0.501 7.15913 0.528 7.28779 0.573 7.41007C0.591 7.45898 0.62 7.49726 0.644 7.54192C0.673 7.59721 0.693 7.65569 0.732 7.70566L5.732 13.0221C5.93 13.2741 6.214 13.4049 6.5 13.4049C6.726 13.4049 6.953 13.3241 7.14 13.1582C7.564 12.7829 7.622 12.1119 7.268 11.6611L3.635 8.08845H17.5C18.052 8.08845 18.5 7.61209 18.5 7.02516C18.5 6.43822 18.052 5.96187 17.5 5.96187Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.03283f1d3846783843401f7f8f8cfea0.svg";
export { ForwardRef as ReactComponent };